import api from './api';
import { LoginRequest, LoginResponse, User } from '../types/auth';

export const authService = {
  async login(request: LoginRequest): Promise<LoginResponse> {
    const { data } = await api.post<LoginResponse>('/api/v1/auth/login', request);
    return data;
  },

  async logout(): Promise<void> {
    await api.post('/api/v1/auth/logout');
  },

  async refreshToken(refreshToken: string): Promise<LoginResponse> {
    const { data } = await api.post<LoginResponse>('/api/v1/auth/refresh', { refreshToken });
    return data;
  },

  async getCurrentUser(): Promise<User> {
    const { data } = await api.get<User>('/api/v1/users/me');
    return data;
  },
};
